<template>
    <div>
        <Label :required="required" :value="label"/>
        <div class="flex space-x-4">
            <div>
                <!-- <breeze-label :value="'Photo'"/> -->
                <input type="file" class="hidden" ref="photo" @change="updatePhotoPreview"
                       accept=".png, .jpg, .jpeg, .webp"/>
                <div v-show="! photoPreview" class="block border rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg"
                             class=" h-24 w-24" viewBox="0 0 20 20"
                         fill="currentColor">
                        <path fill-rule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
                <div v-show="photoPreview">
                                <span class="block border rounded-full h-24 w-24"
                                      :style="'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' + photoPreview + '\');'">
                                </span>
                </div>
            </div>
            <div class="items-center flex ">
                <breeze-button type="button" @click.prevent="selectNewPhoto"
                               v-show="!photoPreview">
                    Select
                </breeze-button>

                <breeze-button type="button" class="bg-red-500 text-white"
                               @click.prevent="deletePhoto"
                               v-show="photoPreview">Remove
                </breeze-button>
            </div>
        </div>
        <div class="col-span-2">
            <InputError :message="errorMessage"/>
        </div>
    </div>
</template>
<script setup>
import BreezeButton from "@/Components/Button";
import InputError from "@/Components/InputError.vue";
import {ref, onMounted} from "vue";
import Label from "@/Components/Label.vue";

const props = defineProps({
    modelValue: [String, Object],
    errorMessage: String,
    oldImage: String,
    required: Boolean,
    label:{
        type:String,
        default:'Profile Image'
    }
})
const emit = defineEmits(['update:modelValue'])
const photo = ref('');
const photoPreview = ref();

onMounted(() => {
    photoPreview.value = props.oldImage;
})

function selectNewPhoto() {
    if (photo.value) {
        photo.value.click();
    }
}

const deletePhoto = () => {
    photoPreview.value = null;

}

function updatePhotoPreview(e) {
    var data = e.target.files || e.dataTransfer.files;
    if (!data.length) return;
    photoPreview.value = URL.createObjectURL(data[0]);
    emit('update:modelValue', data[0])

}
</script>
